export default __webpack_public_path__ + "static/media/vaso-torto.4fe10a5b.svg";